import { TTeam } from 'components/team/helpers/team-types-helper';

type TDataItem = {
    node: {
        id: string;
        name: string;
        surname: string;
        role_id: string;
    };
};

type TSelectOption = {
    label: string;
    value: string;
    disabled: boolean;
};

function convertToSelect(data: TDataItem[]): TSelectOption[] {
    const result: TSelectOption[] = [];

    data?.forEach((item) => {
        result.push({
            label: `${item.node.name} ${item.node.surname}`,
            value: item.node.id,
            disabled: item.node.role_id === "1" || item.node.role_id === "2",
        });
    });

    return result;
}

/**
 * Gets user roles in a particular team
 * @param teams Array of teams or a single team
 * @param userId user ID
 * @param teamId team ID (required if teams is an array)
 * @returns String with user role localization keys or null
 */
function getTeamRoleByUserId(teams: TTeam[] | TTeam, userId?: string, teamId?: string): string | null {
    // If userId is not passed, return null
    if (!userId) return null;

    let team: TTeam | undefined;

    // Determine whether we are working with a single team or an array.
    if (Array.isArray(teams)) {
        // If it's an array, we need the teamId to find the right team.
        if (!teamId) return null;
        team = teams.find(t => t.id === teamId);
    } else {
        // If it's one team, use it
        team = teams;
    }

    // If no team is found or there are no relTeamUsers, return null
    if (!team || !team.relTeamUsers) return null;

    // Find all unique user roles in the team
    const roles = team.relTeamUsers
        .filter(teamUser => teamUser.relUser && teamUser.relUser.id === userId)
        .map(teamUser => teamUser.team_role)
        .filter((role, index, self) => role && self.indexOf(role) === index);

    // Convert roles to localization keys and return the string
    return roles.length > 0 ? roles.map(role => `TEAM_ROLES.${role}`).join(", ") : null;
}


const usersFuncHelper = {
    convertToSelect,
    getTeamRoleByUserId,
};

export default usersFuncHelper;
